export default __webpack_public_path__ + "static/media/bosch.2acb983b.svg";